import { createSlice } from '@reduxjs/toolkit';
import { EmailCodeView, stateName } from './constants';
export const initialState = {
  emailCodeView: EmailCodeView.EnterCode
};

const setEmailCodeView = (draft, action) => {
  draft.emailCodeView = action.payload;
};

const verificationsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setEmailCodeView
  }
});
export const {
  actions
} = verificationsSlice;
export const plug = {
  [stateName]: verificationsSlice.reducer
};
export default verificationsSlice.reducer;